import { SegmentedControl as SC } from './SegmentedControl';
import { SegmentItem } from './components/SegmentItem';
import { SegmentedControlComposition } from './SegmentedControl.types';

const SegmentedControl = SC as SegmentedControlComposition;

SegmentedControl.Item = SegmentItem;

export { SegmentedControl };
